<template>
  <div>
    <Head :title="`Stocktake: ${slug}`" />
    <h1 class="mb-4 text-3xl font-bold">
      <Link
       v-if="team == 'inventory'"
       class="text-orange-400 hover:text-orange-600"
       :href="`/stocktake-references/features/${team}`">
       {{ stocktakeTitle }}
      </Link>
      <Link
        v-else
        class="text-orange-400 hover:text-orange-600"
        :href="`/stocktake-references/features/${team}/${slug}`"
        >
        {{ stocktakeTitle }}
      </Link>
      <span class="text-orange-400 font-medium">/</span> Stocktake
    </h1>
    <div v-if="stocktakeRef.status === 1" class="bg-white rounded-md shadow overflow-hidden mb-5">
      <form @submit.prevent="store">
        <div
          v-if="slug === 'Cages' || slug === 'cages' ||
          slug === 'silos' || slug === 'Silos' ||
          slug === 'woodworking' || slug === 'sofa-production' ||
          slug === 'mattress-finishing'"
          class="flex flex-wrap -mb-2 -mr-6 p-8"
        >
          <div
            class="flex flex-wrap -mb-2 -mr-6 p-8 w-full lg:w-full"
          >
            <text-input
              v-model="form.quantity"
              :error="form.errors.quantity"
              class="pb-2 pr-6 w-full lg:w-1/2"
              placeholder="Quantity"
            />
            <text-input
              v-model="form.part_number"
              :error="form.errors.part_number"
              class="pb-2 pr-6 w-full lg:w-1/2"
              placeholder="Scan Part Number"
            />
          </div>
        </div>
        <div
        v-else-if="slug === 'Racks' || slug === 'racks'"
          class="flex flex-wrap -mb-2 -mr-6 p-8"
        >
          <div class="pb-2 pr-6 mb-3 w-full lg:w-full">
            <Checkbox label="Unbatched Cushions" :active="cushion" @input="cushion = $event"/>
          </div>  
          <div
            class="w-1/2 lg:w-1/2"
          >
            <text-input
              v-model="form.quantity"
              :error="form.errors.quantity"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Quantity"
            />
          </div>
          <div v-show="cushion" class="w-1/2 lg:w-1/2">
            <text-input
              v-model="form.part_number"
              :error="form.errors.part_number"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Scan Part Number"
            />
          </div>
          <div
            v-show="!cushion"
            class="w-1/2 lg:w-1/2"
          >
            <text-input
              v-model="form.item_id"
              :error="form.errors.item_id"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Scan UID"
            />
          </div>
        </div>
        <div
          v-else 
          class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8 pb-8"
        >
          <div class="pb-2 pr-6 mb-3 w-full lg:w-full">
              <Checkbox label="Unbatched Cushions" :active="cushion" @input="cushion = $event"/>
            </div>  
          <div
            v-show="cushion"
            class="w-1/2 lg:w-1/2"
          >
            <text-input
              v-model="form.quantity"
              :error="form.errors.quantity"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Quantity"
            />
          </div>
          <div v-show="cushion" class="w-1/2 lg:w-1/2">
            <text-input
              v-model="form.part_number"
              :error="form.errors.part_number"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Scan Part Number"
            />
          </div>
          <div
            v-show="!cushion"
            class="w-full lg:w-full pb-2 pr-6"
          >
            <text-input
              v-model="form.item_id"
              :error="form.errors.item_id"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Scan UID"
            />
          </div>
        </div>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button
            :loading="form.processing"
            class="btn-orange px-3 py-2 text-xs"
            type="submit"
          >
            Add Count
          </loading-button>
        </div>
      </form>
    </div>
    <div class="flex items-center justify-between mb-6 mt-6 hidden">
      <Link class="btn-orange" href="">
        <span>Add</span>
        <span class="hidden md:inline">&nbsp;Receipt</span>
      </Link>
    </div>
    <hr />
    <ul class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4" id="tabs-tabFill"
      role="tablist">
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-homeFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active
        " id="tabs-home-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
          aria-controls="tabs-homeFill" aria-selected="true">Scans
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-profileFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-profile-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
          aria-controls="tabs-profileFill" aria-selected="false">Report</a>
      </li>
    </ul>
    <div
      class="tab-content" id="tabs-tabContentFill"
    >
      <div class="tab-pane fade show active" id="tabs-homeFill" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="flex items-center justify-between mb-6">
          <a
            v-if="stocktakes.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/stocktakes/receipts/scans/download/${stocktake_ref}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Item UID</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Category</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">Location</th>
              <th class="pb-2 pt-2 px-3" colspan="2">User</th>
            </tr>
            <tr v-for="item in stocktakes.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ item.date }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.item_uid }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.part_no }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.category }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.quantity }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.measure }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.location }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.user }}
                </span>
              </td>
              <td v-show="item.stocktake_reference_status == 1" class="w-px border-t">
                <svg
                  v-if="user.role === 'admin' || user.role === 'manager'"
                  @click="openDeleteModal(item)"
                  xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" style="color: red;" title="Delete">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </td>
            </tr>
            <tr v-if="stocktakes.data.length === 0">
              <td class="px-2 py-2 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="stocktakes.links" />
      </div>
      <div
        class="tab-pane fade" id="tabs-profileFill" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <loading-button
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :loading="generating_report"
            @click="generateReport"
          >
            <span>Generate Report</span>
          </loading-button>
          <a
            v-if="summationReport.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/stocktakes/receipts/download/${stocktakeRef.id}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6">Part Number</th>
              <th class="pb-4 pt-6 px-6">Part Description</th>
              <th class="pb-4 pt-6 px-6">Category</th>
              <th class="pb-4 pt-6 px-6">Count OB</th>
              <th class="pb-4 pt-6 px-6">Receipts</th>
              <th class="pb-4 pt-6 px-6">Issuances</th>
              <th class="pb-4 pt-6 px-6">Transfers</th>
              <th class="pb-4 pt-6 px-6">Expected</th>
              <th class="pb-4 pt-6 px-6">Actual</th>
              <th class="pb-4 pt-6 px-6">Count Variance</th>
              <th class="pb-4 pt-6 px-6">UoM</th>
            </tr>
            <tr
              v-for="inventory in summationReport.data"
              :key="inventory.id"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">
                  {{ inventory.sku_name }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">
                  {{ inventory.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">
                  {{ inventory.category }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">
                  {{ inventory.count_opening_balance }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500 text-right">
                  {{ inventory.receipt_count }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500 text-right">
                  {{ inventory.issuance_count }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500 text-right">
                  {{ inventory.transfer_count }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500 text-right">
                  {{ inventory.expected_count }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">
                  {{ inventory.actual_count }}
                </span>
              </td>
              <td class="border-t">
                <Link
                  v-if ="inventory.is_closed === 'yes'"
                  class="flex items-center px-6 py-4 focus:text-indigo-500"
                  :href="`/stocktakes/${inventory.id}/sku/${inventory.sku_id}/presumed-gains-losses`"
                  tabindex="-1"
                >
                  {{ inventory.actual_count_variance }}
                </Link>
                <span v-else class="flex items-center px-6 py-4 focus:text-indigo-500">{{ inventory.actual_count_variance }}</span>
              </td>
              <td class="w-px border-t text-center">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">
                  {{ inventory.unit_of_measure }}
                </span>
              </td>
            </tr>
            <tr v-if="summationReport.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="4">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="summationReport.links" />
      </div>
    </div>
  </div>
  <!--modal content-->
  <div class="fixed z-10 inset-0 overflow-y-auto" v-if="isOpen">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p>
                You are about to remove a scan with quantity <strong>{{ stocktake_quantity }}</strong>. Proceed?
              </p>
            </div>
          </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button type="button" @click="destroy(stocktake_id)" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5">
              Delete
            </button>
          </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button @click="closeModal" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
              Cancel
            </button>
          </span>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import Checkbox from '@/Shared/Checkbox'
import axios from 'axios'

export default {
  components: {
    Head,
    Icon,
    Link,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
    Checkbox,
  },
  layout: Layout,
  props: {
    filters: Object,
    stocktakes: Object,
    locations: Object,
    stocktakeRef: Object,
    summationReports: Object,
    stocktakeTitle: String,
    download_location_id: Number,
    slug: String,
    stocktake_ref: String,
    coverage_label: String,
    team: String,
  },
  data() {
    return {
      cushion: false,
      form: this.$inertia.form({
        item_id: null,
        quantity: null,
        part_number: null,
      }),
      summationReport: this.summationReports,
      generating_report: false,
      isOpen: false,
      stocktake_quantity: null,
      stocktake_id: null,
    }
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    store() {
      this.form.transform(({...data }) => ({
        location: this.slug,
        stocktake_type: this.coverage_label,
        has_cushion: this.cushion,
        ...data,
      }));
      this.form.post(`/stocktake-reference/${this.stocktakeRef.id}/stocktakes`, {
        onSuccess: () => {
          this.form.reset(
            'item_id',
            'part_number',
            'quantity'
          )
        }
      })
    },
    openDeleteModal(data) {
      this.stocktake_quantity = data.quantity;
      this.stocktake_id = data.id;
      this.isOpen = true;
    },
    closeModal() {
      this.stocktake_quantity = null;
      this.stocktake_id = null;
      this.isOpen = false;
    },
    destroy() {
      const data = {};
      data.id = this.stocktake_id;
      data._method = 'DELETE';
      this.$inertia.post(`/stocktakes/${data.id}/remove`, data)
      this.stocktake_quantity = null;
      this.stocktake_id = null;
      this.closeModal();
    },
    generateReport() {
      const self = this
      this.generating_report = true
      axios.get(`/stocktakes/receipts/generate-report/${this.stocktakeRef.id}`).then(response => {
        if (response) {
          self.summationReport = response.data.data
          self.generating_report = false
        }
      }).catch(function() {
        //
      });
    },
    generateReportInertia() {
      const self = this
      this.generating_report = true
      const summaries_label = this.stocktakeRef.id
      this.$inertia.get(`/stocktake-references/${this.stocktakeRef.id}/features/${this.slug}`, {summaries_label}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
      self.generating_report = false
    },
  },
}
</script>
